import { Component } from '@angular/core';
import { CustomerListComponent, GungModalService } from 'gung-standard';
import { HlCustomerListConfigService } from '../../services/hl-customer-list-config.service';

@Component({
  selector: 'app-hl-display-customer-list',
  templateUrl: './hl-display-customer-list.component.html',
  styleUrl: './hl-display-customer-list.component.css',
  standalone: false
})
export class HlDisplayCustomerListComponent extends CustomerListComponent {
  constructor(
    public customerListConfigService: HlCustomerListConfigService,
    protected gungModalService: GungModalService
  ) {
    super(
      customerListConfigService
    );
  }

  public openAddCustomerModal(): void {
    this.gungModalService.openCreateCustomerModal();
  }
}
